import Utils from '@/common/utils/utils';
import {
    updateChatPostById
} from '@/service/chatPostService';
import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';



/**
 * Observer config
 */
export const observerConfig = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
};



// start process update footprint
// let footprintInterval;
/**
 * Update footprint
 * @param {*} API 
 * @param {*} chatPost 
 * @param {*} userDetail 
 */
const updateFootprint = (API, chatPost, userDetail) => {
    // update status read msg
    if (!Utils.isEmptyObject(chatPost)) {
        let userList = Utils.isEmptyObject(chatPost.footPrint)
            || Utils.isEmptyArray(chatPost.footPrint.userList) ? [] : chatPost.footPrint.userList;
        userList.push(userDetail.id);
        let chatPostInput = {
            id: chatPost.id,
            status: Constant.CHAT_POST_STATUS.READ,
            updatedAt: chatPost.updatedAt,
            footPrint: { userList: userList }
        };
        updateChatPostById(API, chatPostInput);
        // clear interval
        // clearInterval(footprintInterval);
    }
};


/**
 * Process update footprint
 * @param {*} API 
 * @param {*} msg 
 * @param {*} userDetail 
 */
export const processUpdateFootprint = (API, msg, userDetail) => {
    // clearInterval(footprintInterval);
    // footprintInterval = setInterval(() => {
    //     updateFootprint(API, msg, userDetail);
    // }, 2000);
    updateFootprint(API, msg, userDetail);
};

/**
 * Check show status footprint
 * @param {*} userDetail 
 * @param {*} ticketInfo 
 * @returns isShowReadNumber
 */
export const isShowReadNumber = (userDetail, ticketInfo) => {
    if (
        ticketInfo.ticketType === Constant.TICKET_TYPE.TASK ||
        ticketInfo.ticketType === Constant.TICKET_TYPE.EMAIL ||
        ticketInfo.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY
    ) {
        return true;
    }

    if (
        ticketInfo.ticketType === Constant.TICKET_TYPE.BROADCAST_PARENT &&
        userDetail.projectInuse === ticketInfo.projectOrigin
    ) {
        return true;
    }

    if (ticketInfo.ticketType === Constant.TICKET_TYPE.BROADCAST_CHILD) {
        return false;
    }

    if (
        (ticketInfo.ticketType === Constant.TICKET_TYPE.KNOWLEDGE ||
        ticketInfo.ticketType === Constant.TICKET_TYPE.MASTER_KNOWLEDGE) &&
        userDetail.projectInuse === ticketInfo.projectOrigin
    ) {
        return true;
    }

    if (userDetail.projectInuse === ticketInfo.projectOrigin) {
        return false;
    }

    return true;
};



/**
 * Is disabled show read list
 * @param {*} userDetail 
 * @param {*} ticketInfo 
 * @returns isDisabled
 */
export const isDisabledShowReadList = (userDetail, ticketInfo) => {
    if (userDetail.id === ticketInfo.creatorId) {
        return true;
    }
    return false;
};



/**
 * Get footprint number
 * @param {*} footprintDetailList 
 * @param {*} numberFootprintState 
 * @returns footprintNumber
 */
export const getFootprintNumber = (footprintDetailList, numberFootprintState) => {
    if (numberFootprintState > 0) {
        return numberFootprintState;
    }
    return !Utils.isEmptyArray(footprintDetailList) ? footprintDetailList.length : 0;
};


/**
 * Handle intersection footprint
 * @param {*} entries 
 * @param {*} API 
 * @param {*} userDetail 
 * @param {*} chatPostAllList 
 */
export const handleIntersectionFootprint = (entries, API, userDetail, chatPostAllList) => {
    let currentUserId = userDetail.id;
    for (let index in entries) {
        if (!entries[index].isIntersecting) {
            continue;
        }

        // check update read message
        // timeout call api update footprint
        let msgId = entries[index].target.id;
        let msg = chatPostAllList.find(item => item.id === msgId);
        // if (Utils.isEmptyObject(msg)) {
        if (Utils.isEmptyObject(msg) || msg.creatorId === userDetail.id) {
            continue;
        }

        // check msg delete
        if (msg.status === Constant.CHAT_POST_STATUS.DELETE_READ
            || msg.status === Constant.CHAT_POST_STATUS.DELETE) {
            continue;
        }

        let isReadCurrentUser = !Utils.isEmptyObject(msg.footPrint) && !Utils.isEmptyArray(msg.footPrint.userList)
            && msg.footPrint.userList.indexOf(currentUserId) >= 0 ?
            true : false;
        if (isReadCurrentUser) {
            continue;
        }
        // init process update footprint
        processUpdateFootprint(API, msg, userDetail);
    }
};



/**
 * Init intersection observer footprint
 * @param {*} API 
 * @param {*} msgRefList 
 * @param {*} userDetail 
 * @param {*} chatPostAllList 
 * @returns observerFootprint
 */
export const initObserverFootprint = (API, msgRefList,
    userDetail, chatPostAllList) => {
    // create observer
    let observer = new IntersectionObserver(
        entries => handleIntersectionFootprint(entries, API, userDetail, chatPostAllList),
        observerConfig
    );

    // set observe by id
    for (let idRef in msgRefList) {
        if (Utils.isEmptyObject(msgRefList[idRef].current)) continue;
        observer.observe(msgRefList[idRef].current);
    }

    return observer;
};



/**
 * On click popover footprint
 * @param {*} event 
 * @param {*} itemData 
 * @param {*} setFootPrintPopover 
 * @param {*} chatPostAllList 
 * @param {*} setUserFootprintList 
 */
export const onClickPopoverFootprint = (event, itemData,
    setFootPrintPopover, chatPostAllList, setUserFootprintList) => {
    // set footprint popover
    setFootPrintPopover(event.currentTarget);

    let userDetailList = [];
    let index = chatPostAllList.findIndex((element, i) => {
        return element.id === itemData.id;
    });
    chatPostAllList[index]?.footprintListDetail?.forEach(user => (
        // userDetailList.push(<li>{user.firstName} {user.lastName}</li>)
        userDetailList.push(<OverFlowTooltipWithTabsMui value={Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, user)} />)
    ));

    // update footprint
    setUserFootprintList(userDetailList);
};

